/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum ClusterStatus {
  running = 'Running',
  updating = 'Updating',
  creating = 'Creating',
  unavailable = 'Unavailable',
  error = 'Error',
  importing = 'Importing',
}
